/**
 * Senha inicial para o lider entregar a pessoa.
 *
 * Sem os caracteres que se confundem quando alguem le em voz alta ou copia do
 * papel: l, I, 1, O, 0. A senha e gerada aqui e nao no servidor porque quem
 * precisa dela e a tela, para mostrar uma vez — ela nunca volta numa resposta.
 */
export function gerarSenha(): string {
  const letras = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const valores = new Uint32Array(12);
  crypto.getRandomValues(valores);
  return Array.from(valores, (v) => letras[v % letras.length]).join('');
}
